





















































import {Component, Prop, Vue} from "vue-property-decorator";
import ITimeTrackingBrand from "@/models/TimeTracking/ITimeTrackingBrand";

@Component
export default class StatisticsTable extends Vue {
  public name: string = "StatisticsTable";

  @Prop({required: true})
  public statistics: any;

  private durationFormat(secs: number) {

    return this.$moment.utc(secs * 1000)
        .format('HH:mm:ss');

  }

  private onSelectBrandDetails(brand: ITimeTrackingBrand) {

    this.$emit('on-select-brand-details', brand);

  }

}
